import { useState } from "react";
import axios from "axios";
import { Download, Image as ImageIcon, Loader2, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ShareImagePanel = ({ campaign, channel, headers, onCampaign }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const url = campaign.asset_images?.[channel];
  const channelLabel = channel === "x" ? "X" : "LinkedIn";

  const generate = async () => {
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      await axios.post(`${API}/wingman/campaigns/${campaign.campaign_id}/asset-image`, { channel }, { headers: headers(), withCredentials: true, timeout: 60000 });
      const res = await axios.get(`${API}/wingman/campaigns/${campaign.campaign_id}`, { headers: headers(), withCredentials: true });
      onCampaign(res.data);
    } catch (e) {
      setError(e.response?.data?.detail || "Image generation failed.");
    }
    setBusy(false);
  };

  return (
    <div className="bg-[#0A0A0A] border border-white/10 rounded-lg p-6 mt-6" data-testid={`share-image-${channel}`}>
      <div className="flex flex-wrap items-center justify-between gap-4 mb-5">
        <h3 className="font-display text-xl text-white flex items-center gap-2">
          <ImageIcon className="w-5 h-5 text-emerald-400" strokeWidth={1.5} /> {channelLabel} share image
        </h3>
        <button type="button" onClick={generate} disabled={busy} data-testid={`share-image-generate-${channel}`}
          className="h-10 px-5 rounded-full v4-btn-primary text-sm font-semibold flex items-center gap-2 disabled:opacity-40 transition-colors duration-300">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" strokeWidth={1.5} /> : url ? <RefreshCw className="w-4 h-4" strokeWidth={1.5} /> : <ImageIcon className="w-4 h-4" strokeWidth={1.5} />}
          {busy ? "Rendering…" : url ? "Regenerate" : "Generate share image"}
        </button>
      </div>
      {error && <p className="font-mono text-xs text-[#FF3333] mb-4" data-testid={`share-image-error-${channel}`}>{error}</p>}
      {url ? (
        <div data-testid={`share-image-result-${channel}`}>
          <img src={`${url}?v=${encodeURIComponent(campaign.updated_at || "")}`} alt={`${campaign.name} — ${channelLabel} share card`}
            className="block w-full rounded-md border border-white/10" data-testid={`share-image-img-${channel}`} />
          <div className="flex items-center justify-between mt-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-zinc-500">1200 × 630 — brand-locked editorial card</p>
            <a href={url} download={`${campaign.slug}-${channel}-share.png`} data-testid={`share-image-download-${channel}`}
              className="flex items-center gap-1.5 text-xs text-zinc-400 hover:text-white border border-white/10 rounded-full px-3 py-1.5 transition-colors duration-300">
              <Download className="w-3.5 h-3.5" strokeWidth={1.5} /> Download PNG
            </a>
          </div>
        </div>
      ) : (
        !busy && <p className="text-sm text-zinc-400">A 1200×630 card in the Doclyx editorial system — campaign name, the post's hook, DX mark. Attach it when you publish.</p>
      )}
    </div>
  );
};
